// extracted by mini-css-extract-plugin
export default {"container":"Dialog_container__+z2CQ","wrapper":"Dialog_wrapper__jVYqm","block":"Dialog_block__b2yl9","close":"Dialog_close__VBgDQ"};